module.exports = __webpack_public_path__ + "static/img/img5.ebffbc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scenariusze/img/img5.png
// module id = WHGC
// module chunks = 0